<script context="module"></script>

<script>import Blocks from "../../components/blocks/blocks.svelte";
import "../../functions/deopt";
export let builderContext;
export let name;
function stringifyStyles(stylesObj) {
    let styles = "";
    for (let key in stylesObj) {
        const dashedKey = key.replace(/[A-Z]/g, function (match) {
            return "-" + match.toLowerCase();
        });
        styles += dashedKey + ":" + stylesObj[key] + ";";
    }
    return styles;
}
</script>

<div
  style={stringifyStyles({
    pointerEvents: "auto",
  })}
  {...!$builderContext.context?.symbolId && {
    "builder-slot": name,
  }}
>
  <Blocks
    parent={$builderContext.context?.symbolId}
    path={`symbol.data.${name}`}
    context={builderContext}
    blocks={$builderContext.rootState?.[name]}
  />
</div>